import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import type { PromptVersion } from '../../api/generated';

interface VersionDiffDialogProps {
  open: boolean;
  onClose: () => void;
  oldVersion: PromptVersion | null;
  newVersion: PromptVersion | null;
}

export function VersionDiffDialog({
  open,
  onClose,
  oldVersion,
  newVersion,
}: VersionDiffDialogProps) {
  if (!oldVersion || !newVersion) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Compare Versions: v{oldVersion.version} vs v{newVersion.version}
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', gap: 4, mb: 2 }}>
          <Box>
            <Typography variant="caption" sx={{
              color: "text.secondary"
            }}>
              v{oldVersion.version} &middot;{' '}
              {new Date(oldVersion.updated_at).toLocaleDateString()} &middot;{' '}
              {oldVersion.updated_by}
            </Typography>
            {oldVersion.changelog && (
              <Typography variant="body2" sx={{
                color: "text.secondary"
              }}>
                {oldVersion.changelog}
              </Typography>
            )}
          </Box>
          <Box>
            <Typography variant="caption" sx={{
              color: "text.secondary"
            }}>
              v{newVersion.version} &middot;{' '}
              {new Date(newVersion.updated_at).toLocaleDateString()} &middot;{' '}
              {newVersion.updated_by}
            </Typography>
            {newVersion.changelog && (
              <Typography variant="body2" sx={{
                color: "text.secondary"
              }}>
                {newVersion.changelog}
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ fontSize: '0.875rem' }}>
          <ReactDiffViewer
            oldValue={oldVersion.content}
            newValue={newVersion.content}
            splitView
            compareMethod={DiffMethod.WORDS}
            leftTitle={`v${oldVersion.version}`}
            rightTitle={`v${newVersion.version}`}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
